import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PILLARS } from '../../data/content';
export function ProductIntro() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-214" data-mp="2fgspvxwvbm5b">
      <div className="mx-auto max-w-5xl" data-id="element-215" data-mp="2agwlhxk9dsp8">
        <Reveal className="text-center" data-id="element-216" data-mp="2ag50fgoafdd7">
          <SectionBadge tone="dark" data-id="element-217" data-mp="2aj9ct1bwpfey">La solución</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-3xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-218" data-mp="2pcw07r1vir3c">
            Por eso creamos el <span className="u-lime" data-id="element-219" data-mp="2kczwlsx391ob">Megapack Danza Clásica Pro 2026</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-220" data-mp="2y5pjdzkfyamh">
            Todo tu año de clases resuelto en <strong className="font-bold text-snow" data-id="element-221" data-mp="384f3lyzt875w">un solo lugar</strong>, listo
            para usar.
          </p>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-3" data-id="element-222" data-mp="336n0s9xmn0mx">
          {PILLARS.map((pillar, index) => <Reveal key={pillar.title} delay={index * 80} as="article" data-id="element-223" data-mp="2g6oy5ruvkr35" data-mpi={index}>
              <div className="h-full rounded-2xl border border-white/10 bg-ink/90 p-5" data-id="element-224" data-mp="2l3yod9q396s1">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-lime text-sm font-extrabold text-ink" data-id="element-225" data-mp="2q3tf9d9v5wd3">
                  {pillar.n}
                </span>
                <h3 className="mt-4 font-display text-lg text-snow" data-id="element-226" data-mp="2z49da77u8bak">{pillar.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-227" data-mp="2z258ln247898">{pillar.desc}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={110} className="mt-7 text-center" data-id="element-228" data-mp="38v43tns49x1t">
          <p className="inline-flex items-center gap-2 rounded-full border border-lime/40 px-5 py-2.5 text-xs font-bold text-lime sm:text-sm" data-id="element-229" data-mp="3dt5rkm0hmkjm">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-230" data-mp="3hw253yb67qgp" />
            6 tomos + 5 bonos · 100% digital · acceso de por vida
          </p>
        </Reveal>
      </div>
    </section>;
}